import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import { Subset } from '@/api/types/backend-dto-types';
import { useFetcher } from '@/api/useGetFetchConfig';

const PROCESSING_POLL_INTERVAL = 3000;

export const useGetSubset = (matterId?: string, subsetId?: string) => {
  const fetcher = useFetcher();

  return useQuery<Subset, ApiError>(
    [QueryEntity.Subset, { subsetId }],
    () => fetcher(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}`),
    {
      enabled: !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
      refetchInterval: (data) => (data?.status === 'processing' ? PROCESSING_POLL_INTERVAL : false),
    },
  );
};
